import { ReferencePersonDto } from '../../api/generated/model/bezugspersonDto';
import { CreatePersonFormValues, CreatePersonPayload } from '../../api/generated/person/createPerson';
import { trimOrNull } from '../string.ts';

type CreateReferencePersonPayload = Pick<
  ReferencePersonDto,
  'firstName' | 'lastName' | 'position' | 'phoneNumber' | 'email'
> & {
  salutation?: string | null;
};

function mapCreateReferencePersons(referencePersons: ReferencePersonDto[]): CreateReferencePersonPayload[] {
  return referencePersons
    .filter((referencePerson) => referencePerson.isSelected)
    .map((referencePerson) => {
      const referencePersonWithSalutation = referencePerson as ReferencePersonDto & { salutation?: string | null };

      return {
        salutation: referencePersonWithSalutation.salutation || null,
        firstName: referencePerson.firstName,
        lastName: referencePerson.lastName,
        position: referencePerson.position || undefined,
        phoneNumber: referencePerson.phoneNumber || undefined,
        email: referencePerson.email || undefined,
      };
    });
}

/**
 * Maps UI form values into the exact backend payload.
 */
export function mapCreatePersonFormToPayload(values: CreatePersonFormValues): CreatePersonPayload {
  const referencePersons = (values.bezugspersonen ?? []) as ReferencePersonDto[];

  return {
    firstName: values.firstName.trim(),
    lastName: values.lastName.trim(),
    birthDate: values.birthDate,
    gender: values.gender,

    mobilePhoneNumber: trimOrNull(values.mobilePhoneNumber) as string,
    privatePhoneNumber: trimOrNull(values.privatePhoneNumber) as string,
    workPhoneNumber: trimOrNull(values.workPhoneNumber) as string,
    email: trimOrNull(values.email) as string,

    nationality: values.nationality,
    origin: values.origin,
    arrival: trimOrNull(values.arrival),
    asylumNumber: trimOrNull(values.asylumNumber) as string,
    zemisNumber: trimOrNull(values.zemisNumber) as string,
    languages: values.languages,
    residencyPermit: values.residencyPermit,
    additionalInformation: trimOrNull(values.additionalInformation),
    street: trimOrNull(values.street),
    salutation: values.salutation || null,
    livingStatus: values.livingStatus ?? null,
    note: trimOrNull(values.note),
    postalCode: trimOrNull(values.zip),
    city: trimOrNull(values.city),
    state: trimOrNull(values.canton),

    address: null,

    bezugspersonen: mapCreateReferencePersons(referencePersons),
  };
}
